import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../redux/slices/authSlice";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, loading, error } = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password }));
  };

  useEffect(() => {
    // Ensure `user` exists and navigate only once
    if (user?.role) {
      console.log("login.js User:", user);

      // Navigate based on role
      if (user.role === "admin") {
        console.log("Navigating to admin dashboard");
        navigate("/admin", { replace: true }); // Ensure path matches
      } else if (user.role === "user") {
        console.log("Navigating to user dashboard");
        navigate("/patients", { replace: true });
      }
    }
  }, [user, navigate]); // Clean dependency array to avoid loops

  return (
    <Container className="login-container d-flex justify-content-center align-items-center min-vh-100">
      <Row className="w-100">
        <Col xs={12} md={4} className="mx-auto">
          <div
            className="login-box p-4"
            style={{ borderRadius: "10px", backgroundColor: "#E6E6FA" }}
          >
            <h3 className="text-center mb-4">Login</h3>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email:</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password:</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter your password"
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="mx-auto d-block"
                style={{ width: "50%" }}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form>
            {error && (
              <div className="mt-3 text-danger text-center">{error}</div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;



// src/components/Login.js
// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { loginUser } from '../redux/slices/authSlice';
// import { Form, Button, Container, Row, Col } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [role, setRole] = useState('user'); // Default to user role
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { user, loading, error } = useSelector((state) => state.auth);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(loginUser({ email, password, role }));
//   };

//   useEffect(() => {
//     if (user) {
//       toast.success(`Logged in successfully as ${user.user_name}`);
//       if (role === 'admin') {
//         navigate('/admin-dashboard');
//       } else {
//         navigate('/dashboard');
//       }
//     }

//     if (error && typeof error === 'string') {
//       toast.error(error);
//     }
//   }, [user, error, navigate, role]);

//   return (
//     <Container className="login-container d-flex justify-content-center align-items-center min-vh-100">
//       <Row className="w-100">
//         <Col xs={12} md={4} className="mx-auto">
//           <div className="login-box p-4" style={{ borderRadius: '10px', backgroundColor: '#E6E6FA' }}>
//             <h3 className="text-center mb-4">Login</h3>
//             <Form onSubmit={handleSubmit}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email:</Form.Label>
//                 <Form.Control
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                   placeholder="Enter your email"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Password:</Form.Label>
//                 <Form.Control
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   placeholder="Enter your password"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Login as:</Form.Label>
//                 <Form.Select onChange={(e) => setRole(e.target.value)} required>
//                   <option value="user">User</option>
//                   <option value="admin">Admin</option>
//                 </Form.Select>
//               </Form.Group>

//               <Button
//                 variant="primary"
//                 type="submit"
//                 className="mx-auto d-block"
//                 style={{ width: '50%' }}
//                 disabled={loading}
//               >
//                 {loading ? 'Logging in...' : 'Login'}
//               </Button>
//             </Form>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Login;
